/** @format */

export function AppRoutesConfig($stateProvider, AppRoutes) {
    'ngInject';

    $stateProvider.state(AppRoutes.APP, {
        url: '?auctionUrl?projectorId?editMode?token',
        component: 'gbApp',
        params: {
            auctionUrl: null,
            projectorId: null,
            editMode: null,
            token: null,
        },
    });
}
